// extracted by mini-css-extract-plugin
export default {"playRecordsPage":"PlayRecordsPage_playRecordsPage__KRz9a"};